import * as S from './OverviewCard.style';

export default function OverviewCard({ data, count, showAlert, onClick }) {
    const { icon, title, alertLabel } = data;
    return (
        <S.CardContainer onClick={onClick}>
            <div>
                {icon} {title}
            </div>
            <S.CardValueContainer>
                <span>{count}건</span>
                {showAlert && <S.Alert>{alertLabel}</S.Alert>}
            </S.CardValueContainer>
        </S.CardContainer>
    );
}
